const SvgIconInfoOutline = (props) => (
  <svg viewBox="0 0 16 16" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2zM.667 8a7.333 7.333 0 1 1 14.666 0A7.333 7.333 0 0 1 .667 8z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 7.333c.368 0 .667.299.667.667v2.667a.667.667 0 0 1-1.334 0V8c0-.368.299-.667.667-.667zM7.333 5.333c0-.368.299-.666.667-.666h.007a.667.667 0 0 1 0 1.333H8a.667.667 0 0 1-.667-.667z"
      fill="currentColor"
    />
  </svg>
)

export default SvgIconInfoOutline
